<template>
  <div class="main-brokers-table-container">
    <div class="brokers-top-viki-and-charts-container">
      <brokers-top-left-charts-container></brokers-top-left-charts-container>
      <notifications></notifications>
      <BrokersTopRightChartsContainer></BrokersTopRightChartsContainer>
    </div>
    <div class="middle-section-brokers-table">
      <brokers-table></brokers-table>
    </div>
    <div class="bottom-section-brokers-table">
      <left-bottom-chart></left-bottom-chart>
      <div class="tempLikeViki">
        <general-live-stats-sub-chart />
      </div>
      <security-cams></security-cams>
      <right-bottom-chart></right-bottom-chart>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import BrokersTable from "./BrokersTable.container";
import Notifications from "../../msg_center.feature/containers/Notifications.component";
import BrokersTopLeftChartsContainer from "../../brokers.feature/charts.sub_featue.brokers/containers/BrokersTopLeftChartsContainer";
import BrokersTopRightChartsContainer from "../../brokers.feature/charts.sub_featue.brokers/containers/BrokersTopRightChartsContainer";
import SecurityCams from "../../security.feature/containers/SecurityCams.container";
import GeneralLiveStatsSubChart from "../../company.feature/sub_features.company/graph.sub-feature.company/components/GeneralLiveStatsSubChart.component";
import LeftBottomChart from "../../company.feature/sub_features.company/graph.sub-feature.company/containers/LeftBottomChart.container";
import RightBottomChart from "../../company.feature/sub_features.company/graph.sub-feature.company/containers/RightBottomChart.container";
export default {
  name: "Brokers.container",
  components: {
    BrokersTopRightChartsContainer,
    BrokersTopLeftChartsContainer,
    Notifications,
    BrokersTable,
    SecurityCams,
    GeneralLiveStatsSubChart,
    LeftBottomChart,
    RightBottomChart
  }
};
</script>

<style scoped>
.brokers-top-viki-and-charts-container {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}

.bottom-section-brokers-table {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}

.tempLikeViki {
  min-width: calc(10%);
  max-width: calc(10%);
  max-height: 100%;
}
</style>
